/*
 * Mobile navigation resilience fallback.
 *
 * The legacy theme occasionally renders the mobile drawer without binding its
 * controller.  This keeps the native handler first; only when it has not
 * changed the drawer/submenu state does this small fallback apply the same
 * classes the controller uses.
 */
(function () {
  'use strict';

  function afterNative(handler) {
    window.setTimeout(handler, 40);
  }

  function drawer() {
    return document.getElementById('MobileNav');
  }

  function setOpen(isOpen) {
    var nav = drawer();
    if (!nav) return;

    nav.classList.toggle('is-active', isOpen);
    document.documentElement.classList.toggle('mobile-nav-open', isOpen);
    document.querySelectorAll('.mobile-nav-trigger').forEach(function (trigger) {
      trigger.classList.toggle('is-active', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function goToSubmenu(button) {
    var nav = drawer();
    if (!nav) return;

    var wrapper = nav.querySelector('.slide-nav__wrapper');
    var menu = nav.querySelector('.slide-nav');
    if (!wrapper || !menu) return;

    var target = button.getAttribute('data-target');
    var targetMenu = target
      ? menu.querySelector('.slide-nav__dropdown[data-parent="' + target.replace(/"/g, '\\"') + '"]')
      : null;

    if (!targetMenu) {
      wrapper.dataset.level = '1';
      wrapper.removeAttribute('style');
      menu.querySelectorAll('.slide-nav__dropdown.is-active').forEach(function (item) {
        item.classList.remove('is-active');
      });
      return;
    }

    var level = targetMenu.dataset.level || '2';
    if (level === '2') {
      menu.querySelectorAll('.slide-nav__dropdown[data-level="3"].is-active').forEach(function (item) {
        item.classList.remove('is-active');
      });
    }
    targetMenu.classList.add('is-active');
    wrapper.dataset.level = level;
    wrapper.style.height = targetMenu.offsetHeight + 'px';
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest && event.target.closest('.mobile-nav-trigger');
      if (!trigger) return;

      var nav = drawer();
      if (!nav) return;
      var wasOpen = nav.classList.contains('is-active');

      afterNative(function () {
        // A working native controller has changed the state; never compete.
        if (nav.classList.contains('is-active') !== wasOpen) return;
        setOpen(!wasOpen);
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('#MobileNav .js-toggle-submenu');
      if (!button) return;

      var nav = drawer();
      var wrapper = nav && nav.querySelector('.slide-nav__wrapper');
      if (!wrapper) return;
      var levelBefore = wrapper.dataset.level;

      afterNative(function () {
        // Native navigation moved us already.
        if (wrapper.dataset.level !== levelBefore) return;
        goToSubmenu(button);
      });
    },
    true
  );
})();
